<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">{{tables.para_info.title}}</div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.para_info.page"
            :length="tables.para_info.pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.para_info.total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="tables.para_info.rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="tables.para_info.rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="tables.para_info.data"
        :headers="tables.para_info.headers"
        hide-default-header
        :items-per-page="tables.para_info.rows"
        :loading="tables.para_info.isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.para_info.headers"
                :key="header.value"
              >
                <div
                  @click="changeSort(header, tables.para_info)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&tables.para_info.sortItem===header.value">
                    <v-icon v-if="tables.para_info.sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in tables.para_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='actions'">
                <v-icon
                  size = "35"
                  color="primary"
                  style="cursor: pointer;"
                  @click="openDialog(tables.para_info, item)"
                >
                  mdi-pencil
                </v-icon>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增編輯dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.para_info.dialogEdit" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{tables.para_info.selectedData.para_caption}}</v-card-title>
          <v-card-text>
            <v-form :ref="tables.para_info.formEditRef">
              <div class="rowDiv contentCenter">
                <div style="width:200px">
                  <v-text-field
                    label="編號"
                    v-model="tables.para_info.selectedData.para_sn"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                    :rules="rules.content"
                  ></v-text-field>
                </div>
                <div style="width:200px" class="ml-2">
                  <v-text-field
                    label="類型"
                    v-model="tables.para_info.selectedData.para_type"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                    :rules="rules.content"
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:200px">
                  <v-text-field
                    label="值"
                    v-model="tables.para_info.selectedData.para_value"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
                <div style="width:200px" class="ml-2">
                  <v-text-field
                    label="標題"
                    v-model="tables.para_info.selectedData.para_caption"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialog(tables.para_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveData(tables.para_info)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    
    
    <v-card flat class="rounded-lg py-2 mt-5" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">{{tables.kv_info.title}}</div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.kv_info.page"
            :length="tables.kv_info.pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.kv_info.total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="tables.kv_info.rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="tables.kv_info.rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="tables.kv_info.data"
        :headers="tables.kv_info.headers"
        hide-default-header
        :items-per-page="tables.kv_info.rows"
        :loading="tables.kv_info.isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.kv_info.headers"
                :key="header.value"
              >
                <div
                  @click="changeSort(header, tables.kv_info)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&tables.kv_info.sortItem===header.value">
                    <v-icon v-if="tables.kv_info.sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in tables.kv_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='actions'">
                <v-icon
                  size = "35"
                  color="primary"
                  style="cursor: pointer;"
                  @click="openDialogKV(tables.kv_info, item)"
                >
                  mdi-pencil
                </v-icon>
              </div>
              <div v-else-if="header.value==='key'">
                {{tables.kv_info.descDict.hasOwnProperty(item[header.value]) ? tables.kv_info.descDict[item[header.value]] : '' }}({{item[header.value]}})
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增編輯dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.kv_info.dialogEdit" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{tables.kv_info.descDict.hasOwnProperty(tables.kv_info.selectedData.key) ? tables.kv_info.descDict[tables.kv_info.selectedData.key] : ''}}</v-card-title>
          <v-card-text>
            <v-form :ref="tables.kv_info.formEditRef">
              <div class="rowDiv contentCenter">
                <div style="width:240px" class="font-weight-bold text-h5">
                  {{tables.kv_info.selectedData.key}}：
                </div>
                <div style="width:240px" class="ml-2">
                  <v-textarea
                    :label="tables.kv_info.desc"
                    v-model="tables.kv_info.selectedData.value"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    rows="3"
                  ></v-textarea>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialog(tables.kv_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveData(tables.kv_info)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>

import Service from '../service/service'
export default {
  name: 'Para_Info',
  data: () => ({
    tables: {
      para_info: {
        isLoading: false,
        title: '系統參數管理',
        formEditRef: 'paraForm',
        formDeleteRef: '',
        urlGet: 'para_info/getPageData',
        urlUpdate: 'para_info/update',
        headers: [
          { text: '編號', value: 'para_sn',  sortable: true },
          { text: '類型', value: 'para_type',  sortable: true },
          { text: '值', value: 'para_value',  sortable: true },
          { text: '標題', value: 'para_caption',  sortable: true },
          { text: '', value: 'actions', sortable: false }
        ],
        rows: 50,
        sortItem: 'key',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10, 20, 30, 40, 50],
        search: {
          user_id: {
              name: 'USERID',
              value: '',
              displayType: 'like'
          },
          user_true_name: {
              name: 'USERNAME',
              value: '',
              displayType: 'like'
          }
        },
        data: [],
        selectedData: { 
          para_sn: '',
          para_type: '',
          para_value: '',
          para_caption: ''
        },
        dialogEdit: false
      },
      kv_info: {
        isLoading: false,
        title: '進階功能管理',
        desc: 'value 請以逗號(,)分隔',
        formEditRef: 'kvForm',
        formDeleteRef: '',
        urlGet: 'para_info/GetPageDataKV',
        urlUpdate: 'para_info/UpdateKV',
        headers: [
          { text: 'key', value: 'key',  sortable: false },
          { text: 'value', value: 'value',  sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        rows: 50,
        sortItem: 'key',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10, 20, 30, 40, 50],
        search: {
        },
        data: [],
        selectedData: { 
          key: '',
          value: ''
        },
        dialogEdit: false,
        descDict: {
          'FUNC_CTRL_AI': '可以使用 偵測與遮蔽區塊設定 中的 AI設定功能',
          'FUNC_CTRL_MFI': '可以使用 模型管理 中的 上傳圖片 功能',
          'FUNC_MENU_203': '可以使用 系統維護管理 中的 設備匯入作業 與 系統參數管理 頁面',
          'FUNC_MENU_MFI': '可以使用 系統維護管理 中的 模型管理 頁面'
        }
      }
    },
    rules: {
      content: [v => !!v || 'Required']
    }
  }),
  mounted: function () {
    this.getPageData(this.tables.para_info)
    this.getPageData(this.tables.kv_info)
  },
  watch: {
    'tables.para_info.page': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData(this.tables.para_info) }
      }
    },
    'tables.para_info.rows': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.para_info.page === 1 ? this.getPageData(this.tables.para_info) : this.tables.para_info.page = 1 }
      }
    },
    
    'tables.kv_info.page': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData(this.tables.kv_info) }
      }
    },
    'tables.kv_info.rows': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.kv_info.page === 1 ? this.getPageData(this.tables.kv_info) : this.tables.kv_info.page = 1 }
      }
    },
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header, table) {
      if (!header.sortable) return

      if (header.value === table.sortItem) {
        table.sortOrder = !table.sortOrder
      } else {
        table.sortOrder = true
        table.sortItem = header.value
      }
      this.getPageData(table)
    },
    openDialog (table, item) {
      table.selectedData.para_sn = item.para_sn
      table.selectedData.para_type = item.para_type
      table.selectedData.para_value = item.para_value
      table.selectedData.para_caption = item.para_caption
      table.dialogEdit = true
    },
    closeDialog (table) {
      table.dialogEdit = false
      this.resetSelectedData()
      if (this.$refs[table.formEditRef]) {
        this.$refs[table.formEditRef].resetValidation()
      }
      // // 暫時特別重取頁面資料
      // this.getPageData(table)
    },
    getPageData (table) {
      table.isLoading = true
      table.pageCount = 0
      table.data = []
      var wheres = []
      var parm = {
        page: table.page,
        rows: table.rows,
        order: table.sortOrder ? 'desc' : 'asc',
        sort: table.sortItem,
        wheres: JSON.stringify(wheres),
        url: table.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            table.total = response.data.total
            table.pageCount = Math.ceil(table.total / table.rows)
            table.data = response.data.rows
            // console.log(table.data)
          }
        })
      .finally(() => {
        table.isLoading = false
      })
    },
    saveData (table) {
      if (this.$refs[table.formEditRef].validate()) {
        Service.updateData(table.selectedData, table.urlUpdate)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData(table)
              this.closeDialog(table)
            }
          })
      }
    },
    resetSelectedData () {
      var selectedData = this.tables.para_info.selectedData
      selectedData.para_sn = ''
      selectedData.para_type = ''
      selectedData.para_value = ''
      selectedData.para_caption = ''
    },

    
    openDialogKV (table, item) {
      table.selectedData.key = item.key
      table.selectedData.value = item.value
      table.dialogEdit = true
    },
  }
}
</script>
